export default "__VITE_ASSET__09d3fbe9__"